import { $Q, $Qll } from "../utils/query-selector";

const toggleButton = () => {
  const loadMoreBtn = $Q("#loadMoreBtn");
  const total = $Q('[data-total]').dataset.total;
  const items = $Qll('.marketplace-item');

  if( items.length >= total) {
    loadMoreBtn.style.display = "none";
  }
}

/**
 * The function loads more content when a button is
 * clicked and sends a request to the server to retrieve
 * the additional content.
 */
const loadMore = () => {
  const loadMoreBtn = $Q("#loadMoreBtn");

  loadMoreBtn.addEventListener("click", function (event) {
    const filterCategory = event.target.dataset.category;
    const filterPublic = event.target.dataset.public;
    const offset = parseInt(event.target.dataset.offset);
    const container = $Q("#partnersContainer");
    const data = new FormData();
    data.append("paged", 1);
    data.append("offset", offset);
    if (filterCategory != 0 || filterPublic != 0) {
      data.append("filtered", 1);
    } else {
      data.append("filtered", 0);
    }
    const filters = JSON.stringify({ category: filterCategory });
    data.append("filters", filters);
    data.append("action", "marketplaces_load_more");

    fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      body: data,
    })
      .then((response) => console.log(response.status) || response) // output the status and return response
      .then((response) => response.text()) // send response body to next then chain
      .then((data) => {
        const loadedPostsHTML = JSON.parse(data).data;
        if (loadedPostsHTML == "") {
          event.target.style.display = "none";
        } else {
          container.innerHTML += loadedPostsHTML;
          event.target.dataset.offset = offset + 9;
        }
        toggleButton();
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

loadMore();
toggleButton();
